import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

function tsMs(val) {
  if (!val) return null;
  if (typeof val?.toMillis === "function") return val.toMillis();
  if (typeof val?.seconds === "number") return val.seconds * 1000;
  return null;
}

export default function AnnouncementBanner() {
  const [text, setText] = useState("");
  const [startMs, setStartMs] = useState(null);
  const [endMs, setEndMs] = useState(null);

  useEffect(() => {
    const ref = doc(db, "app_config", "panel");
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const d = snap.data() || {};
        setText(String(d.announcementBanner || "").trim());
        setStartMs(tsMs(d.announcementStart));
        setEndMs(tsMs(d.announcementEnd));
      },
      () => {
        setText("");
      }
    );
    return () => unsub();
  }, []);

  const now = Date.now();
  if (!text) return null;
  if (startMs != null && now < startMs) return null;
  if (endMs != null && now > endMs) return null;

  return (
    <div
      role="status"
      className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-sm text-amber-950"
    >
      <span className="font-semibold">Notice: </span>
      {text}
    </div>
  );
}
